import Table from 'react-bootstrap/Table'

function ViewDirAdtva({selectedDirAdtva}) {
    return (
        <Table striped bordered hover>
            <tbody>
                <tr>
                    <th>Código</th>
                    <td>{selectedDirAdtva.codigo}</td>
                </tr>
                <tr>
                    <th>Descripción</th>
                    <td>{selectedDirAdtva.descripcion}</td>
                </tr>
            </tbody>
        </Table>
    )
}

export default ViewDirAdtva